import connector from 'Utils/connector';
import GetAppButton from 'Webapp/shared/app/components/get-app-button';
import { usageTrackTapOpenInAppButton } from 'Webapp/shared/app/redux/actions/usage-actions';

export default connector({ actions: { usageTrackTapOpenInAppButton } })(
  GetAppButton,
);
